import classnames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { FilterHidingContextButton } from '../controls/FilterBar';
import PanelButtons, { PanelButton } from '../controls/PanelButtons';
import styles from './Strike.scss';
import useHelpNoteTitle from './Translations/useHelpNoteTitle';
import useTranslation from './Translations/useTranslation';
import { isRTL } from '../../utils/commonHelper';
const Strike = ({ icon = 'plus3', buttonComponent: Component = null, iconClassName = '', wrapperClassName = '', panelButtonClassName = '', iconType = '', badge = '', isDisable = false, title, titleComponent, onClick, className, buttonTitle = '', isSubsection = false, hoverTitle = '', tooltipTitle = '', isPageTitle = false, isButtonVisible = true, isCollapsible = false, isCollapsed = false, isSectionEcontent = false, required = false, buttonDataCy, onToggleCollapse, onTitleClick, }) => {
    const { t } = useTranslation();
    const handleClick = useCallback(e => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        onClick && onClick(e);
    }, [onClick]);
    const buttonHoverTitle = buttonTitle || t('Add');
    const resolvedButtonTooltipTitle = useHelpNoteTitle(buttonHoverTitle, tooltipTitle);
    const resolvedTitleTooltipTitle = useHelpNoteTitle(title || hoverTitle || '', tooltipTitle);
    const button = useMemo(() => Component ? (<div className={classnames({
        [styles['custom-button']]: !isSectionEcontent,
    })}>
          <Component icon={icon} isDisable={isDisable} title={buttonHoverTitle} onClick={handleClick}/>
        </div>) : (<PanelButton badge={badge} className={iconClassName} dataCy={buttonDataCy} icon={icon} isDisabled={isDisable} title={buttonHoverTitle} tooltipTitle={resolvedButtonTooltipTitle} type={iconType} onClick={handleClick}/>), [
        Component,
        badge,
        buttonHoverTitle,
        handleClick,
        icon,
        iconClassName,
        iconType,
        isDisable,
        buttonDataCy,
        resolvedButtonTooltipTitle,
    ]);
    const collapseButton = useMemo(() => {
        if (!isCollapsible || !onToggleCollapse) {
            return null;
        }
        return (<PanelButton className={classnames({
            [styles.econtentCollapseButton]: isSectionEcontent,
        })} icon={isCollapsed ? 'arrow-down2' : 'arrow-up2'} iconClassName={classnames({
            [styles.titleStyleEcontent]: isSectionEcontent,
        })} title={isCollapsed ? t('Expand section') : t('Collapse section')} onClick={onToggleCollapse}/>);
    }, [isCollapsible, onToggleCollapse, isSectionEcontent, isCollapsed, t]);
    const titleElement = useMemo(() => (isPageTitle ? <h5 className={styles.pageTitle}>{title}</h5> : title), [isPageTitle, title]);
    return (<div className={classnames(className, 'strike', {
        'no-padding-top': isPageTitle,
        [styles.sectionStyleEcontent]: !isPageTitle && isSectionEcontent,
    })}>
      {collapseButton}
      {titleComponent}
      {title && (<span className={classnames('section-style', wrapperClassName, {
        'no-margin-top': isPageTitle,
        [styles.titleStyle]: !isPageTitle && isSubsection && !isSectionEcontent,
        [styles.sectionStyle]: !isPageTitle && !isSubsection,
        [styles.titleClickable]: onTitleClick,
        [styles.rtl]: isRTL(titleElement),
        [styles.titleStyleEcontent]: !isPageTitle && isSectionEcontent,
        [styles.titleStyleEcontentWithoutCollapse]: !isPageTitle && isSectionEcontent && !collapseButton,
    })} title={resolvedTitleTooltipTitle || hoverTitle} onClick={onTitleClick}>
          {titleElement}
          {required && <span className="text-danger">&nbsp;*</span>}
        </span>)}
      <PanelButtons className={panelButtonClassName}>
        <FilterHidingContextButton hasDivider={!!((isButtonVisible && onClick && button) || collapseButton)}/>
        {isButtonVisible && onClick && button}
      </PanelButtons>
    </div>);
};
export default Strike;
